import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActionButtonModule } from '../action-button/action-button.module';
import { ShipmentWaybillMainInfoEditDialogComponent } from './shipment-waybill-main-info-edit-dialog.component';
import { ChipFieldModule } from '../chip-field';
import { IntrackFeatureModule } from '../../intrack-feature.module';

@NgModule({
  declarations: [ShipmentWaybillMainInfoEditDialogComponent],
  imports: [
    CommonModule,
    IntrackFeatureModule,
    ReactiveFormsModule,
    TranslateModule,
    ActionButtonModule,
    ChipFieldModule,
  ],
  exports: [ShipmentWaybillMainInfoEditDialogComponent],
})
export class ShipmentWaybillMainInfoEditDialogModule {}
